enum IExportFormat {
    SWOFI = 0,
    Literature_Wizard = 1,
}

export default IExportFormat;



// WEBPACK FOOTER //
// ./src/interfaces/IExportFormat.ts